<template>
  <div class="content">
    <div class="search-box btn3">
      <div class="input-item">
        <span class="label">业务员工号</span>
        <Input v-model="searchParams.staffNo" placeholder="请输入" clearable />
      </div>

      <div class="input-item">
        <span class="label">业务员姓名</span>
        <Input v-model="searchParams.name" placeholder="请输入" clearable />
      </div>

      <div class="input-item">
        <span class="label">业务员状态</span>
        <Select v-model="searchParams.workStatus" filterable clearable>
          <Option value="1">在职</Option>
          <Option value="2">离职</Option>
          <Option value="3">停职</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">出单机构/团队</span>
        <selectTree type="2" v-model="searchParams.orgId" @change="changeOrg" :isAll="true"></selectTree>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="warning" @click="daochu()">导出</Button>
      </div>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}/{{ row.salesmanName }}</span>
            </div>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center" />
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
export default {
  mixins: [pageTool, common],
  components: { selectTree },
  props: ['actId'],
  data() {
    return {
      searchParams: {},
      tableData: [],
      total: 0,
      columns: [
        {
          title: '序号',
          align: 'center',
          type: 'index',
          width: 80
        },
        {
          title: '业务员工号',
          key: 'staffNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '业务员姓名',
          key: 'name',
          align: 'center',
          minWidth: 150
        },
        {
          title: '业务员状态',
          align: 'center',
          key: 'workStatus',
          minWidth: 100
        },
        {
          title: '所属机构',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            return <span>{params.row.orgName}</span>;
          }
        },
        {
          title: '所属团队',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            return <span>{params.row.groupName}</span>;
          }
        }
      ],
      nodeType: ''
    };
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    changeOrg(data) {
      this.nodeType = data.nodeType;
    },

    getList() {
      this.listLoading = true;
      let data = {
        ...this.searchParams,
        activityId: this.actId,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.nodeType == 2) {
        data.groupId = data.orgId;
        delete data.orgId;
      }
      this.$http({
        url: '/buz/merchantActivity/queryActivitySignupInfo',
        type: 'POST',
        data
      }).then(res => {
        this.listLoading = false;
        this.tableData = res.data;
        this.total = res.total;
      });
    },

    changePage(num) {
      this.pageNum = num;
      this.getList();
    },

    daochu() {
      let data = {
        ...this.searchParams,
        activityId: this.actId
      };
      if (this.nodeType == 2) {
        data.groupId = data.orgId;
        delete data.orgId;
      }
      this.$units.downloadFile('/buz/merchantActivity/exportActivitySignupInfo', data, 'POST');
    }
  }
};
</script>
